module.exports = __webpack_public_path__ + "images/category_lp/common/reason3-woman-20@2x_e59c6f429b4528095bf49915a60c178b.jpg";